import i18next from "i18next";
import Decimal from "decimal.js";
import { PhoneNumberUtil } from "google-libphonenumber";
import {
  clearSessionStorage,
  removeSessionStorageItem,
} from "./sessionStorage";
import { getDecryptPayload } from "./encryption";
import { removeLocalStorageItem, getLocalStorageItem } from "./localStorage";
import {
  roles,
  StorageKeys,
  sportConstants,
  globalConstants,
  translationConstants,
  availableServicesConstants,
  UserVerificationApprovalStatus,
  documentStatusConstants,
  timezoneConstants,
  emptyString,
  boatTypeEnum,
  levelEnum,
  proficiencyLevelEnum,
  boatTypeEnumReversed,
  levelEnumReversed,
  proficiencyLevelEnumReversed,
  calculationOperations,
} from "../constants";
import moment from "moment-timezone";

import {
  SailingIcon,
  KiteSurfingIcon,
  WindSurfingIcon,
  WingFoilingIcon,
} from "../assets/images/sportsIcon";

const { Pending, Approved } = UserVerificationApprovalStatus;

export const FileName = (componentTitle) => {
  const today = new Date();
  const fileName = `${i18next.t(componentTitle)}_${today.getFullYear()}-${
    today.getMonth() + 1 < 10 ? "0" : ""
  }${today.getMonth() + 1}-${
    today.getDate() < 10 ? "0" : ""
  }${today.getDate()}_${
    today.getHours() < 10 ? "0" : ""
  }${today.getHours()}${String.fromCharCode(0xa789)}${
    today.getMinutes() < 10 ? "0" : ""
  }${today.getMinutes()}`;

  return fileName;
};

export const CurrentDate = () => {
  const today = new Date();
  const currentDate = `${today.getFullYear()}-${
    today.getMonth() + 1 < 10 ? "0" : ""
  }${today.getMonth() + 1}-${
    today.getDate() < 10 ? "0" : ""
  }${today.getDate()}  ${today.getHours() < 10 ? "0" : ""}${today.getHours()}:${
    today.getMinutes() < 10 ? "0" : ""
  }${today.getMinutes()}`;

  return currentDate;
};

export const currentDateInString = (date = null) => {
  if (date) {
    return new Date(date).toISOString().split("T")[0];
  }
  return new Date().toISOString().split("T")[0];
};

// //Time and Date Merging function
export const mergeDateTime = (dateObject, timeObject) => {
  // Create a new Date object from the dateObject
  const combinedDateTime = new Date(dateObject.getTime());
  // Set the time parts from the timeObject to the combinedDateTime
  combinedDateTime.setHours(timeObject.getHours());
  combinedDateTime.setMinutes(timeObject.getMinutes());
  combinedDateTime.setSeconds(timeObject.getSeconds());
  combinedDateTime.setMilliseconds(timeObject.getMilliseconds());
  const combinedDateTimeInInt64 = combinedDateTime.getTime() / 1000;
  return Math.floor(combinedDateTimeInInt64);
};

// date of birth in integer64
export const formatDOB = (dateOfBirth) => {
  const DOB = new Date(dateOfBirth);
  const dateOfBirthInInt64 = DOB.getTime() / 1000;
  return dateOfBirthInInt64;
};

// format data 10000223333 to  'MM-DD-YYYY' format
export function formatExpiry(unixTimestamp) {
  // Create a new Date object from the Unix timestamp
  const date = new Date(unixTimestamp * 1000); // Convert from seconds to milliseconds

  // Get the month, day, and year from the date
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // getMonth() returns 0-11
  const day = date.getDate().toString().padStart(2, "0");
  const year = date.getFullYear();

  // Format the date as 'MM-DD-YYYY'
  const dateString = `${month}-${day}-${year}`;

  return dateString;
}

// Function to extract time from a Unix timestamp
export function formatUnixTime(unixTimestamp) {
  // Create a new Date object from the Unix timestamp
  const date = new Date(unixTimestamp * 1000); // Convert from seconds to milliseconds

  // Get the hours, minutes, and seconds from the date
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  // Format the time as 'hh:mm:SS'
  const timeString = `${hours}:${minutes}:${seconds}`;

  return timeString;
}

export function getSingleDateIfEqual(firstDate, secondDate) {
  // Convert timestamps to Moment.js objects and set to the start of the day
  const firstDateMoment = moment.unix(firstDate).startOf("day");
  const secondDateMoment = moment.unix(secondDate).startOf("day");

  // Check if both dates are the same
  if (firstDateMoment.isSame(secondDateMoment, "day")) {
    return ` ${new Date(firstDate * 1000).toLocaleDateString()}`; // Return the first date if both dates are the same
  } else {
    return ` ${new Date(firstDate * 1000).toLocaleDateString()} - ${new Date(
      secondDate * 1000
    ).toLocaleDateString()}`; // Return null or some other value if the dates are different
  }
}

export const getUserToken = () => {
  // Try to get userData from localStorage
  let userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : null;

  // If not found in localStorage, try sessionStorage
  if (!userData || !userData.token) {
    userData = sessionStorage.getItem("userData")
      ? JSON.parse(sessionStorage.getItem("userData"))
      : null;
  }

  // Return the token if userData and token are found, else return an empty string
  return userData && userData.token ? userData.token : "";
};

// Function to convert "Mon, Sep 11, 2023" to "2023-09-11"
export const formatDate = (dateString) => {
  const dateObj = new Date(dateString);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatTime = (dateString) => {
  // Parse the date string into a Date object
  const date = new Date(dateString);
  // Format the hours and minutes
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  // Return the formatted time
  return `${hours}:${minutes}`;
};

export const generateFileName = (dataToSend, componentName) => {
  // Assuming dataToSend.data.data is your array and componentName is a string
  const dataArray = dataToSend.data.data;
  const firstDate = dataArray[0].date; // Assuming date is a property of your objects
  const lastDate = dataArray[dataArray.length - 1].date;

  // Remove empty spaces from componentName
  const trimmedComponentName = componentName.trim();

  const formattedFirstDate = formatDate(firstDate);
  const formattedLastDate = formatDate(lastDate);

  const result = `${trimmedComponentName}_${formattedLastDate} "to"${formattedFirstDate}`;

  return result;
};

export const generateFileNameForExport = (componentName, dateRange) => {
  let formattedLastDate = formatDate(dateRange[0].startDate);
  let formattedFirstDate = formatDate(dateRange[0].endDate);

  // Remove empty spaces from componentName
  const trimmedComponentName = componentName.trim();

  const result = `${trimmedComponentName}_${formattedLastDate} "to" ${formattedFirstDate}`;

  return result;
};

export const clearUserData = () => {
  removeSessionStorageItem(process.env.REACT_APP_PAYLOAD);
  removeLocalStorageItem(process.env.REACT_APP_PAYLOAD);
  removeLocalStorageItem(StorageKeys.Role);
  removeLocalStorageItem(StorageKeys.userVerificationDocumentStatus);
  removeLocalStorageItem(StorageKeys.userSportDocumentStatus);
  removeLocalStorageItem(StorageKeys.Token);
  removeSessionStorageItem(StorageKeys.userVerificationDocumentStatus);
  removeSessionStorageItem(StorageKeys.Role);
  removeSessionStorageItem(StorageKeys.userSportDocumentStatus);
  removeSessionStorageItem(StorageKeys.Token);
  removeSessionStorageItem(StorageKeys.KeepMeSignedIn);
  clearSessionStorage();
};

export const getCurrentUserRole = () => {
  let userPayload = getUserPayload();
  let userRole = userPayload?.user?.role;
  return userRole ?? "";
};

export const getToken = () => {
  const payload = getLocalStorageItem(StorageKeys.Token);
  // Return the token if userData and token are found, else return an empty string
  return payload?.token ?? "";
};

export const getUserPayload = () => {
  // Try to get userData from localStorage
  let userData = localStorage.getItem(process.env.REACT_APP_PAYLOAD)
    ? JSON.parse(localStorage.getItem(process.env.REACT_APP_PAYLOAD))
    : null;

  // If not found in localStorage, try sessionStorage
  if (!userData) {
    userData = sessionStorage.getItem(process.env.REACT_APP_PAYLOAD)
      ? JSON.parse(sessionStorage.getItem(process.env.REACT_APP_PAYLOAD))
      : null;
  }

  return userData ? getDecryptPayload(userData) : "";
};

export const getPractionerDocumentStatus = () => {
  // Try to get userData from localStorage
  let status = localStorage.getItem(StorageKeys.userSportDocumentStatus);

  // If not found in localStorage, try sessionStorage
  if (!status) {
    status = sessionStorage.getItem(StorageKeys.userSportDocumentStatus);
  }

  return status;
};

export const getUserStatus = () => {
  // Try to get userData from localStorage
  let status = localStorage.getItem(StorageKeys.userVerificationDocumentStatus);

  // If not found in localStorage, try sessionStorage
  if (!status) {
    status = sessionStorage.getItem(StorageKeys.userVerificationDocumentStatus);
  }

  return status;
};

export const changeTableSortIcons = (columns, sortedColumn) => {
  return columns.map((col) => {
    if (col.id === sortedColumn.id) {
      return {
        ...col,
        sortDirection: getSortDirectionProperty(col),
      };
    } else {
      return {
        ...col,
        sortDirection: null,
      };
    }
  });
};

export const getSortDirectionProperty = (column) => {
  if (column.sortDirection === null) {
    return globalConstants.SORT.ASC;
  } else if (column.sortDirection === globalConstants.SORT.ASC) {
    return globalConstants.SORT.DESC;
  } else {
    return null;
  }
};

export const getAgeInYears = (dob) => {
  // Convert the timestamp to a Date object
  const birthdate = new Date(dob);

  // Get the current date
  const currentDate = new Date();

  // Calculate the age by subtracting the birthdate from the current date
  const ageInMilliseconds = currentDate - birthdate;
  let ageInYears = ageInMilliseconds / (365.25 * 24 * 60 * 60 * 1000);
  return ageInYears;
};

export const getFormattedDateTime = (milliseconds) => {
  const date = new Date(milliseconds);

  const formattedDate = date.toLocaleString("en-US", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    timeZoneName: "short",
  });
  return formattedDate;
};

export const getIsMobile = (breakpoint) => window.innerWidth <= breakpoint;

export const isShowPractitionerButton = (role, userData) => {
  const localStorageItem = getLocalStorageItem(
    StorageKeys.userSportDocumentStatus
  );

  const userSportDocumentStatus = localStorageItem;

  return (
    role === roles.VerifiedUser &&
    userSportDocumentStatus !== Pending &&
    (userData.practionerStatus !== Approved ||
      userData.practionerStatus !== Pending ||
      userData.practionerStatus !== null)
  );
};

//Function allows instructor button when either document status is pending in storage
//If not then check if instructor status is pending or approve in auth call
export const isShowInstructorButton = (role, userData) => {
  const localStorageItem = getLocalStorageItem(StorageKeys.instructorStatus);

  const instructorStatus = localStorageItem;
  return (
    instructorStatus !== Pending &&
    (userData.instructorStatus !== Approved ||
      userData.instructorStatus !== Pending ||
      userData.instructorStatus !== null)
  );
};

export const isShowFreelanceButton = (role) => {
  const localStorageItem = getLocalStorageItem(StorageKeys.freelanceStatus);

  const freelanceStatus = localStorageItem;

  return role !== roles.FreelanceInstructor && freelanceStatus !== Pending;
};

/**
 * Function to replace service IDs with corresponding names.
 * @param {string} services - The string containing service IDs.
 * @param {Function} t - The translation function.
 * @returns {string} - The string with replaced service names.
 */
export const replaceServicesIdWithName = (services, t) => {
  const replacements = {
    [availableServicesConstants.BEGINNER_LESSONS]:
      translationConstants.BEGINNER_LESSONS,
    [availableServicesConstants.ADVANCED_LESSONS]:
      translationConstants.ADVANCED_LESSONS,
    [availableServicesConstants.EQUIPMENT_RENTALS]:
      translationConstants.EQUIPMENT_RENTALS,
    [availableServicesConstants.RESCUE]: translationConstants.RESCUE,
  };

  let replacedString = services;
  for (const key in replacements) {
    if (replacements.hasOwnProperty(key)) {
      replacedString = `${replacedString}`.replace(
        key,
        ` ${t(replacements[key])}`
      );
    }
  }
  return replacedString;
};

/**
 * Function to replace sports IDs with corresponding names.
 * @param {string} sports - The string containing sports IDs.
 * @param {Function} t - The translation function.
 * @returns {string} - The string with replaced sports names.
 */
export const replaceSportsIdWithName = (sports, t) => {
  const replacements = {
    [sportConstants.SAILING]: translationConstants.SAILING,
    [sportConstants.KITESURFING]: translationConstants.KITE_SURFING,
    [sportConstants.WINDSURFING]: translationConstants.WIND_SURFING,
    [sportConstants.WINGFOILING]: translationConstants.WING_FOILING,
  };

  let replacedString = sports;
  for (const key in replacements) {
    if (replacements.hasOwnProperty(key)) {
      replacedString = `${replacedString}`.replace(
        key,
        ` ${t(replacements[key])}`
      );
    }
  }
  return replacedString;
};

/**
 * Function to convert an object into FormData recursively.
 * @param {Object} obj - The object to convert.
 * @param {FormData} formData - The FormData object to append the converted data to.
 * @param {string} parentKey - The parent key used for nested object properties.
 * @returns {FormData} - The FormData object containing the converted data.
 */
export const convertObjectToFormData = (
  obj,
  formData = new FormData(),
  parentKey = ""
) => {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      let propName = parentKey ? `${parentKey}.${key}` : key;
      // If the value is a File, directly append it to FormData
      if (obj[key] instanceof File) {
        formData.append(propName, obj[key]);
      } else if (Array.isArray(obj[key])) {
        // If the value is an array
        // Iterate through the array elements
        obj[key].forEach((item, index) => {
          const arrayKey = `${propName}[${index}]`;
          // If the array element is an object (non-File), recursively convert it
          if (typeof item === "object" && !(item instanceof File)) {
            convertObjectToFormData(item, formData, arrayKey);
          } else {
            // Otherwise, append the array element to FormData
            formData.append(arrayKey, item);
          }
        });
      } else if (typeof obj[key] === "object" && !(obj[key] instanceof File)) {
        // If the value is an object (non-File)
        // Recursively convert the object
        convertObjectToFormData(obj[key], formData, propName);
      } else {
        // Otherwise, append the value to FormData
        formData.append(propName, obj[key]);
      }
    }
  }
  return formData; // Return the FormData object
};

// Convert the epoch to a Date Object
export const epochToDateObject = (date) => {
  if (date) {
    if (!isNaN(date)) {
      date = new Date(date * 1000);
    }
  }
  return date;
};

// Console the formData object
export const logFormData = (formData) => {
  for (let [key, value] of formData.entries()) {
    console.log(key, value);
  }
};

/**
 * Function to retrieve a sport object by name.
 * @param {string} name - The name of the sport.
 * @returns {Object|null} - The sport object or null if not found.
 */
export const getSportObjByName = (name) => {
  const sportMapping = {
    [sportConstants.SAILING]: {
      value: sportConstants.SAILING,
      label: translationConstants.sailing,
    },
    [sportConstants.KITESURFING]: {
      value: sportConstants.KITESURFING,
      label: translationConstants.KITE_SURFING,
    },
    [sportConstants.WINDSURFING]: {
      value: sportConstants.WINDSURFING,
      label: translationConstants.WIND_SURFING,
    },
    [sportConstants.WINGFOILING]: {
      value: sportConstants.WINGFOILING,
      label: translationConstants.WING_FOILING,
    },
  };

  return sportMapping[+name] || null;
};

export const antSwitchStyle = (theme) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : "#007F58",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
});

export const downloadBase64File = (base64Data, contentType, fileName) => {
  const linkSource = `data:${contentType};base64,${base64Data}`;
  const downloadLink = document.createElement("a");
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};

export const formatDateFromEpoch = (epochTimestamp) => {
  // Convert epoch to milliseconds
  const date = new Date(epochTimestamp * 1000);

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  //Get day, month, and year from the date object
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  //Format the date string
  const formattedDate = `${day} ${monthNames[monthIndex]} ${year}`;

  return formattedDate;
};

export const formatDateFromEpochWith3MonthLetters = (epochTimestamp) => {
  // Convert epoch to milliseconds
  const date = new Date(epochTimestamp * 1000);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  //Get day, month, and year from the date object
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  //Format the date string
  const formattedDate = `${day} ${monthNames[monthIndex]} ${year}`;

  return formattedDate;
};

// format data 10000223333 to  'MM-DD-YYYY' format
export function formatDateTOString(unixTimestamp) {
  // Create a new Date object from the Unix timestamp
  const date = new Date(unixTimestamp * 1000); // Convert from seconds to milliseconds

  // Get the month, day, and year from the date
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // getMonth() returns 0-11
  const day = date.getDate().toString().padStart(2, "0");
  const year = date.getFullYear();

  // Format the date as 'MM-DD-YYYY'
  const dateString = `${day}/${month}/${year}`;

  return dateString;
}

// format data 10000223333 to  'MM-DD-YYYY HH:MM' format
export function formatDateTimeTOString(unixTimestamp) {
  // Create a new Date object from the Unix timestamp
  const date = new Date(unixTimestamp * 1000); // Convert from seconds to milliseconds

  // Get the month, day, year, hours, and minutes from the date
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // getMonth() returns 0-11
  const day = date.getDate().toString().padStart(2, "0");
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  // Format the date as 'MM-DD-YYYY HH:MM'
  const dateString = `${month}-${day}-${year} ${hours}:${minutes}`;

  return dateString;
}

export const findConstantValue = (value, constant) => {
  for (const key in constant) {
    if (constant[key] === value) {
      return key;
    }
  }
  return null; // Value not found in constant
};

export const googleLocationUrl = (lat, long) => {
  return `https://www.google.com/maps/search/?api=1&query=${lat},${long}`;
};

// debounce for searching
export const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export const CommaSplitToTranslatedCommaJoined = (data, t) => {
  const translateData = data?.split(", ").map((item) => {
    return t(translationConstants[item]);
  });
  const translatedData = translateData?.join(", ");
  return translatedData;
};

export const removeSpace = (string) => {
  if (string === " " || string === null) {
    return null;
  } else {
    return string;
  }
};

export const allowOnlyNumbers = (evt) => {
  const charCode = evt.which || evt.keyCode;

  // Allow numeric (0-9), numpad numeric (96-105)
  if (
    (charCode >= 48 && charCode <= 57) ||
    (charCode >= 96 && charCode <= 105)
  ) {
    return true;
  }

  // Allow control keys: backspace (8), tab (9), enter (13), delete (46), arrows (37-40)
  if (
    charCode === 8 || // backspace
    charCode === 9 || // tab
    charCode === 13 || // enter
    charCode === 46 || // delete
    (charCode >= 37 && charCode <= 40) || // arrow keys
    (charCode === 65 && (evt.ctrlKey || evt.metaKey)) || // Ctrl+A or Cmd+A
    (charCode === 67 && (evt.ctrlKey || evt.metaKey)) || // Ctrl+C or Cmd+C
    (charCode === 86 && (evt.ctrlKey || evt.metaKey)) || // Ctrl+V or Cmd+V
    (charCode === 88 && (evt.ctrlKey || evt.metaKey)) // Ctrl+X or Cmd+X
  ) {
    return true;
  }

  // Prevent other keys
  evt.preventDefault();
  return false;
};

export const moveBack = () => {
  window.history.back();
};

// Helper function to get Document Name by Id
export const getDocumentStatusName = (value) => {
  return Object.keys(documentStatusConstants)
    .find((key) => documentStatusConstants[key] === value)
    .toUpperCase();
};
export function getEpochMonthStartAndEndDate(dateFilter) {
  // Ensure dateFilter is a moment object
  if (!moment.isMoment(dateFilter)) {
    throw new Error("Input must be a moment object.");
  }

  const monthWithFirstDate = dateFilter.clone().date(1).startOf("day");
  const monthWithLastDate = dateFilter.clone().endOf("month").endOf("day");

  const epochMonthWithFirstDate = Math.floor(
    monthWithFirstDate.valueOf() / 1000
  );
  const epochMonthWithLastDate = Math.floor(monthWithLastDate.valueOf() / 1000);

  return {
    epochMonthWithFirstDate,
    epochMonthWithLastDate,
  };
}

export const isPhoneValid = (phone) => {
  const phoneUtil = PhoneNumberUtil.getInstance();
  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
  } catch (error) {
    return false;
  }
};

export const copyToClipboard = (text) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
  } else {
    // Fallback for older browsers
    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  }
};

export const DaysLeft = (startDate, endDate) => {
  const start = moment.unix(startDate);
  const end = moment.unix(endDate);

  // Calculate the difference in days
  const daysLeft = end.diff(start, "days");
  // Format the number of days to always be two digits
  const formattedDays = daysLeft < 10 ? `0${daysLeft}` : daysLeft;
  return formattedDays;
};

// Function to round a number to a specific number of decimal places
export const roundToDecimalPlaces = (num = 0, decimalPlaces = 2) => {
  return new Decimal(num).toDecimalPlaces(decimalPlaces).toNumber();
};

//Calculate the VAT using VAT percentage and subtotal price
export const calculateVAT = (vat = 0, subTotalPrice = 0) => {
  const vatAmount = new Decimal(vat).div(100).times(subTotalPrice);
  return roundToDecimalPlaces(vatAmount, 2);
};

//Calculation Function for addition, subtraction etc... for decimal places
export const precisionCalculation = (
  firstValue = 0,
  secondValue = 0,
  operation
) => {
  const num1 = new Decimal(firstValue);
  const num2 = new Decimal(secondValue);
  let result;

  switch (operation) {
    case calculationOperations.addition:
      result = num1.plus(num2);
      break;
    case calculationOperations.subtraction:
      result = num1.minus(num2);
      break;
    case calculationOperations.multiplication:
      result = num1.times(num2);
      break;
    case calculationOperations.division:
      result = num2.isZero() ? new Decimal(0) : num1.dividedBy(num2);
      break;
    default:
      throw new Error(`Unsupported operation: ${operation}`);
  }

  return result.toNumber();
};

//============================================================================
// New Functions For Timezone Changes
//============================================================================

// This Function will be used for custom timezone
export const dateToUTCWithTimezone = (date) => {
  // Convert the given date to UTC and add 3 hours for a custom timezone adjustment
  return moment.utc(date).add(3, "hours");
};

/**
 * Converts a date to an ISO string format, with an optional number of days to add.
 *
 * @param {number} daysToAdd - The number of days to add to the date.
 * @param {string} date - The input date string.
 * @returns {string} The ISO string representation of the adjusted date.
 */
export function UTCWithTimezoneToISOString(daysToAdd = 0, date) {
  // Parse the UTC time using the dateToUTCWithTimezone function
  const momentUtc = dateToUTCWithTimezone(date);
  // Add the specified number of days to the UTC time
  momentUtc.add(daysToAdd, "days");
  // Get the local time from the adjusted UTC moment object
  const localTime = momentUtc.local();
  // Format the local time as an ISO string and replace 'Z' with the local offset
  const localIsoString = localTime
    .toISOString()
    .replace("Z", localTime.format("Z"));
  return localIsoString;
}

/**
 * Formats a given UTC date to 'YYYY-MM-DD HH:mm:ss' format.
 *
 * @param {Date} utcDate - The UTC date object to format.
 * @returns {string} The formatted date string in 'YYYY-MM-DD HH:mm:ss'.
 */
export const formattedUTCDate = (utcDate) => {
  const dateFormat = `${utcDate.getUTCFullYear()}-${String(
    utcDate.getUTCMonth() + 1
  ).padStart(2, "0")}-${String(utcDate.getUTCDate()).padStart(2, "0")} ${String(
    utcDate.getUTCHours()
  ).padStart(2, "0")}:${String(utcDate.getUTCMinutes()).padStart(
    2,
    "0"
  )}:${String(utcDate.getUTCSeconds()).padStart(2, "0")}`;

  return dateFormat;
};

/**
 * Creates a new date object with specified adjustments to year, month, day, and time.
 *
 * @param {Date} dateObject - The base date object to adjust.
 * @param {number} yearToAdd - Years to add.
 * @param {number} monthToAdd - Months to add.
 * @param {number} dayToAdd - Days to add.
 * @param {number} hourToAdd - Hours to add (default is 3 for timezone adjustment).
 * @param {number} minuteToAdd - Minutes to add.
 * @param {number} secondToAdd - Seconds to add.
 * @param {number} millisecondToAdd - Milliseconds to add.
 * @returns {Date} The adjusted date object.
 */
export const customDateObject = (
  dateObject,
  yearToAdd = 0,
  monthToAdd = 0,
  dayToAdd = 0,
  hourToAdd = 3,
  minuteToAdd = 0,
  secondToAdd = 0,
  millisecondToAdd = 0
) => {
  // Use the provided date object or the current date if none is given
  const now = dateObject ? dateObject : new Date();
  // Create a new UTC date object with the specified adjustments
  const utcDate = new Date(
    Date.UTC(
      now.getUTCFullYear() + yearToAdd,
      now.getUTCMonth() + monthToAdd,
      now.getUTCDate() + dayToAdd,
      now.getUTCHours() + hourToAdd,
      now.getUTCMinutes() + minuteToAdd,
      now.getUTCSeconds() + secondToAdd,
      now.getUTCMilliseconds() + millisecondToAdd
    )
  );
  return utcDate;
};

/**
 * Converts a server date string in 'YYYY-MM-DD HH:mm:ss' format to a JavaScript Date object.
 *
 * @param {string} dateString - The date string from the server.
 * @returns {Date|null} The corresponding Date object or null if input is invalid.
 */
export const serverFormatToDateObject = (dateString) => {
  if (dateString) {
    return moment(
      dateString,
      timezoneConstants.dateTimeFormatForServer
    ).toDate();
  }
  return null;
};

/**
 * Converts a server date string in 'YYYY-MM-DD HH:mm:ss' format to a Moment object.
 *
 * @param {string} dateString - The date string from the server.
 * @returns {Object|null} The corresponding Moment object or null if input is invalid.
 */
export const serverFormatToMomentObject = (dateString) => {
  if (dateString) {
    return replaceLocalToUTCFormatZ(dateString);
  }
  return null;
};

/**
 * Formats a server date string to a specified format (e.g., 'MM-DD-YYYY').
 *
 * @param {string} dateString - The date string from the server.
 * @param {string} format - The desired output format.
 * @returns {string|null} The formatted date string or null for unsupported formats.
 */
export function serverFormatToDateString(dateString, format) {
  // Parse the date string into a Moment object using the server format
  const date = moment(dateString, timezoneConstants.dateTimeFormatForServer);
  // Check if the parsed date is valid
  if (!date.isValid()) {
    return emptyString; // Return an empty string for invalid dates
  }
  // Check if the format is one of the predefined formats
  if (
    format === timezoneConstants.dayMonthYearFormat ||
    format === timezoneConstants.hourMinuteFormat ||
    format === timezoneConstants.dateTimeFormatForTimeStamp
  ) {
    // Format the date based on the specified format
    return date.format(format);
  }
  // Return null for unsupported formats
  return null;
}

/**
 * Merges a date object and a time object into a single server format date string.
 *
 * @param {Date} dateObject - The date object to merge.
 * @param {Date} timeObject - The time object to merge.
 * @returns {string} The combined date and time in server format.
 */
export const mergeDateTimeToServerFormat = (dateObject, timeObject) => {
  // Create a Moment object from the dateObject
  const dateMoment = moment(dateObject);
  // Set the time parts from the timeObject
  dateMoment.hours(timeObject.getHours());
  dateMoment.minutes(timeObject.getMinutes());
  dateMoment.seconds(timeObject.getSeconds());
  dateMoment.milliseconds(timeObject.getMilliseconds());
  // Convert to a string in the server's date-time format
  const combinedDateTimeString = dateMoment.format(
    timezoneConstants.dateTimeFormatForServer
  );
  return combinedDateTimeString;
};

/**
 * Converts a date object to a server date format string.
 *
 * @param {Date} dateObject - The date object to convert.
 * @returns {string} The date string in server format.
 */
export const dateObjectToServerFormat = (dateObject) => {
  // Convert the dateObject to a Moment object and set to the start of the day
  const dateMoment = moment(dateObject);
  // Convert to string in server format
  const dateString = dateMoment.format(
    timezoneConstants.dateTimeFormatForServer
  );
  return dateString;
};

/**
 * Compares two server date strings and returns a single date string if they are equal.
 *
 * @param {string} firstDate - The first date string to compare.
 * @param {string} secondDate - The second date string to compare.
 * @returns {string} A formatted date string if both are the same; otherwise, a range string.
 */
export function toSingleDateStringIfEqual(firstDate, secondDate) {
  // Convert timestamps to Moment.js objects and set to the start of the day
  const firstDateMoment = moment(
    firstDate,
    timezoneConstants.dateTimeFormatForServer
  ).startOf("day");
  const secondDateMoment = moment(
    secondDate,
    timezoneConstants.dateTimeFormatForServer
  ).startOf("day");

  // Check if both dates are the same
  if (firstDateMoment.isSame(secondDateMoment, "day")) {
    return ` ${serverFormatToDateString(
      firstDate,
      timezoneConstants.dayMonthYearFormat
    )}`; // Return the first date if both dates are the same
  } else {
    return ` ${serverFormatToDateString(
      firstDate,
      timezoneConstants.dayMonthYearFormat
    )} - ${serverFormatToDateString(
      secondDate,
      timezoneConstants.dayMonthYearFormat
    )}`; // Return a range string if the dates are different
  }
}

/**
 * Calculates the age in years based on the provided date of birth string.
 *
 * @param {string} dobString - The date of birth string in server format.
 * @returns {number} The calculated age in years.
 */
export const getAgeInYearsWithMoment = (dobString) => {
  // Parse the dobString using serverFormatToMomentObject
  const birthdate = serverFormatToMomentObject(dobString);

  // Get the current date using dateToUTCWithTimezone
  const currentDate = dateToUTCWithTimezone();

  // Calculate the age in years
  const ageInYears = currentDate.diff(birthdate, "years");
  return ageInYears;
};

/**
 * Calculates the number of days left until the event ends.
 *
 * @param {string} endDate - The end date string in server format.
 * @returns {string} The formatted number of days left, always two digits.
 */
export const dashboardEventDaysLeft = (endDate) => {
  const start = dateToUTCWithTimezone().startOf("day"); // Get the current moment with timezone adjustment
  const end = serverFormatToMomentObject(endDate).startOf("day"); // Convert end date string to Moment object
  // Calculate the difference in days
  const daysLeft = end.diff(start, "days");
  // Format the number of days to always be two digits
  const formattedDays = daysLeft < 10 ? `0${daysLeft}` : daysLeft;
  return formattedDays;
};

/**
 * Formats a date/time range from two server date/time strings.
 *
 * @param {string} startDateTimeString - The start date/time string from the server.
 * @param {string} endDateTimeString - The end date/time string from the server.
 * @param {string} format - The desired format for the output string.
 * @returns {string} The formatted date/time range string.
 */
export const formatDateTimeRangeFromServer = (
  startDateTimeString,
  endDateTimeString,
  format
) => {
  // Generate the formatted string for the start and end date/time using the provided format
  const combinedString = ` ${serverFormatToDateString(
    startDateTimeString,
    format
  )} - ${serverFormatToDateString(endDateTimeString, format)}`;

  return combinedString;
};

/**
 * Creates a label with an optional mandatory character and timezone text.
 *
 * @param {string} label - The base label to which the mandatory sign and timezone text will be appended.
 * @param {function} t - Translation function used to translate the timezone display text.
 * @param {boolean} [isShowMandatory=true] - Flag indicating whether to show the mandatory character. Defaults to true.
 * @param {string} [customClass] - Optional custom class to be added to the timezone display span.
 * @returns {JSX.Element} The formatted label with the optional mandatory character and timezone text in a span.
 */
export const appendMandatorySignAndTimezoneText = (
  label,
  t,
  isShowMandatory = true,
  customClass
) => {
  return (
    <>
      {label}:{isShowMandatory && globalConstants.Mandatory_Character}{" "}
      <span
        className={`timezone-display-text ${customClass ? customClass : ""}`}
      >
        {t(translationConstants.TIMEZONE_DISPLAY_ON_FIELD)}
      </span>
    </>
  );
};

/**
 * Replaces the local timezone offset with the UTC offset in the given date.
 *
 * @param {string|Date|moment} data - The date to be converted. This can be a
 *                                      string, a Date object, or a moment object.
 * @returns {moment} A moment object representing the date with the local timezone
 *                   offset replaced by the UTC offset.
 */
export const replaceLocalToUTCFormatZ = (data) => {
  // Get the local timezone offset in "Z" format
  const localTime = moment().format("Z");
  // Get the UTC timezone offset in "Z" format using a custom function
  const UTCTime = dateToUTCWithTimezone().format("Z");
  // Replace the local timezone offset with the UTC offset in the formatted date string
  const zFormatChanged = moment(data).format().replace(localTime, UTCTime);
  // Return the modified date as a moment object
  return moment.utc(zFormatChanged);
};

//============================================================================
// New Functions For Sports Changes
//============================================================================

/**
 * Mapping of sports to their corresponding boat types, levels and proficiency levels.
 *
 * Each sport can have multiple boat types, and each boat type can have different levels,
 * which in turn can contain various proficiency levels.
 * Structure Example:
 * {
 *   [sportConstants.SAILING]: {
 *     [boatTypeEnum.DINGHY]: {
 *       levels: {
 *         [levelEnum.AMATEUR]: [proficiencyLevelEnum.BEGINNER, ...],
 *         ...
 *       }
 *     },
 *     ...
 *   },
 *   ...
 * }
 */

export const sportRelationship = {
  [sportConstants.SAILING]: {
    [boatTypeEnum.DINGHY]: {
      levels: {
        [levelEnum.AMATEUR]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
        [levelEnum.RACER]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
        [levelEnum.ELITE]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
      },
    },
    [boatTypeEnum.KEELBOAT]: {
      levels: {
        [levelEnum.AMATEUR]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
        [levelEnum.RACER]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
        [levelEnum.ELITE]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
      },
    },
    [boatTypeEnum.MULTI_HULL]: {
      levels: {
        [levelEnum.AMATEUR]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
        [levelEnum.RACER]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
        [levelEnum.ELITE]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
      },
    },
    [boatTypeEnum.YACHT]: {
      levels: {
        [levelEnum.AMATEUR]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
        [levelEnum.RACER]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
      },
    },
  },
  [sportConstants.KITESURFING]: {
    [boatTypeEnum.FORMULA_KITE]: {
      levels: {
        [levelEnum.AMATEUR]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
        [levelEnum.RACER]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
        [levelEnum.ELITE]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
      },
    },
    [boatTypeEnum.KITE_BOARDER]: {
      levels: {
        [levelEnum.AMATEUR]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
        [levelEnum.RACER]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
      },
    },
  },
  [sportConstants.WINDSURFING]: {
    [boatTypeEnum.IQFOIL]: {
      levels: {
        [levelEnum.AMATEUR]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
        [levelEnum.RACER]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
        [levelEnum.ELITE]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
      },
    },
    [boatTypeEnum.WIND_SURFER]: {
      levels: {
        [levelEnum.AMATEUR]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
        [levelEnum.RACER]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
      },
    },
  },
  [sportConstants.WINGFOILING]: {
    [boatTypeEnum.FORMULA_WING]: {
      levels: {
        [levelEnum.AMATEUR]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
        [levelEnum.RACER]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
        [levelEnum.ELITE]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
      },
    },
    [boatTypeEnum.WING_FOILER]: {
      levels: {
        [levelEnum.AMATEUR]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
        [levelEnum.RACER]: [
          proficiencyLevelEnum.BEGINNER,
          proficiencyLevelEnum.INTERMEDIATE,
          proficiencyLevelEnum.ADVANCED,
        ],
      },
    },
  },
};

/**
 * Get options for dropdown based on sport, boat type, and level.
 *
 * @param {function} t - Translation function to localize labels.
 * @param {number} sportId - The ID of the sport (e.g., sportConstants.SAILING).
 * @param {number} [boatTypeId] - The ID of the boat type (optional).
 * @param {number} [levelId] - The ID of the level (optional).
 * @returns {Array} - An array of objects suitable for dropdown options, each containing
 *                    a `label` and a `value`. Returns an empty array if no valid options.
 */
export const getSportDataForDropdown = (t, sportId, boatTypeId, levelId) => {
  // Check if the sportId exists
  if (!sportRelationship[sportId]) {
    return []; // Return an empty array if the sportId is invalid
  }

  // If only sportId is provided, return all boat types for that sport
  if (boatTypeId === undefined) {
    return Object.keys(sportRelationship[sportId]).map((boatType) => ({
      label: boatTypeEnumReversed[boatType], // You can customize the label translation here
      value: boatType,
    }));
  }

  // Check if the boatTypeId exists for the given sportId
  const boatTypeData = sportRelationship[sportId][boatTypeId];
  if (!boatTypeData) {
    return []; // Return an empty array if the boatTypeId is invalid
  }

  // If sportId and boatTypeId are provided, return all levels for that boat type
  if (levelId === undefined) {
    return Object.keys(boatTypeData.levels).map((level) => ({
      label: levelEnumReversed[level], // Customize the label translation here
      value: level,
    }));
  }

  // Check if the levelId exists for the given boatTypeId
  const levelData = boatTypeData.levels[levelId];
  if (!levelData) {
    return []; // Return an empty array if the levelId is invalid
  }

  // If all three parameters are provided, return the proficiency levels for that level
  return levelData.map((proficiencyLevel) => ({
    label: proficiencyLevelEnumReversed[proficiencyLevel], // Customize the label translation here
    value: proficiencyLevel,
  }));
};

/**
 * Converts a given object (or array) into a FormData object for easier handling of form submissions.
 *
 * @param {Object|Array} obj - The object or array to be converted to FormData.
 * @param {FormData} [formData=new FormData()] - The FormData object to which the properties will be appended.
 * @param {string} [parentKey=""] - The parent key used to build nested keys in FormData (for recursive calls).
 * @returns {FormData} - The constructed FormData object.
 */
export const certificatesDataToFormData = (
  obj,
  formData = new FormData(),
  parentKey = ""
) => {
  // Iterate through the properties of the object
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      // Construct the property name with parent key if it exists
      let propName = parentKey ? `${parentKey}.${key}` : key;

      // If the value is a File, directly append it to FormData
      if (obj[key] instanceof File) {
        formData.append(propName, obj[key]);
      }
      // If the value is an array, handle its elements
      else if (Array.isArray(obj[key])) {
        // Iterate through each element of the array
        obj[key].forEach((item, index) => {
          // If the array element is an object (non-File), recursively convert it
          if (typeof item === "object" && !(item instanceof File)) {
            certificatesDataToFormData(item, formData, `${propName}[${index}]`);
          }
          // Append File instances without the index
          else if (item instanceof File) {
            formData.append(propName, item);
          }
          // Otherwise, append the array element to FormData with the index
          else {
            formData.append(`${propName}[${index}]`, item);
          }
        });
      }
      // If the value is an object (non-File), recursively convert it
      else if (typeof obj[key] === "object" && !(obj[key] instanceof File)) {
        certificatesDataToFormData(obj[key], formData, propName);
      }
      // Otherwise, append the value to FormData
      else {
        formData.append(propName, obj[key]);
      }
    }
  }
  // Return the FormData object
  return formData;
};

/**
 * Formats and returns a translated string for level and proficiency level.
 *
 * @param {number} levelId - The ID of the level to be translated.
 * @param {number} [proficiencyLevelId] - The optional ID of the proficiency level to be translated.
 * @returns {string} The formatted string containing the level translation and the proficiency level (if provided).
 */
export const getLevelAndProficiencyLevel = (t, levelId, proficiencyLevelId) => {
  // Translate the levelId using translation constants
  const levelTranslation = t(translationConstants[levelEnumReversed[levelId]]);

  // Translate proficiencyLevelId if provided, otherwise return an empty string
  const proficiencyTranslation = proficiencyLevelId
    ? ` - ${t(
        translationConstants[proficiencyLevelEnumReversed[proficiencyLevelId]]
      )}`
    : "";

  // Return the concatenated level and proficiency translations
  return `${levelTranslation}${proficiencyTranslation}`;
};

/**
 * Returns the corresponding sport icon and heading based on the provided sport ID.
 * @param {t} - This is an instance of useTranslation from the "react-i18next" library
 * @param {number|string} sportId - The ID of the sport, which can be passed as a number or string.
 *                                  It is converted to a number to ensure consistency.
 * @returns {Object} An object containing:
 *   - {Image Source} icon: The icon component representing the sport.
 *   - {string} heading: The translated heading string for the sport.
 *                       If the sportId doesn't match any case, both icon and heading will be null.
 */
export const getSportIconAndHeading = (t, sportId) => {
  switch (Number(sportId)) {
    case sportConstants.SAILING:
      return { icon: SailingIcon, heading: t(translationConstants.SAILING) };
    case sportConstants.KITESURFING:
      return {
        icon: KiteSurfingIcon,
        heading: t(translationConstants.KITE_SURFING),
      };
    case sportConstants.WINDSURFING:
      return {
        icon: WindSurfingIcon,
        heading: t(translationConstants.WIND_SURFING),
      };
    case sportConstants.WINGFOILING:
      return {
        icon: WingFoilingIcon,
        heading: t(translationConstants.WING_FOILING),
      };
    default:
      // Return null values if sportId does not match any known sport
      return { icon: null, heading: null };
  }
};

/**
 * Retrieves and decrypts the user's boat class data for competition registration from local storage.
 *
 * @returns {Object|null} - The decrypted payload containing the user's boat class data, or `null` if no data is found.
 */
export const getUserBoatClass = () => {
  // Retrieves the encrypted user boat class data from local storage
  const encryptedData = localStorage.getItem(
    StorageKeys.userBoatClassForCompetitionRegistration
  );
  // Parses the JSON string and decrypts the payload, returning the decrypted boat class data
  return encryptedData ? getDecryptPayload(JSON.parse(encryptedData)) : null;
};
